import { render, staticRenderFns } from "./Alipaychange.vue?vue&type=template&id=78c65f9f&scoped=true&"
import script from "./Alipaychange.vue?vue&type=script&lang=js&"
export * from "./Alipaychange.vue?vue&type=script&lang=js&"
import style0 from "./Alipaychange.vue?vue&type=style&index=0&id=78c65f9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c65f9f",
  null
  
)

component.options.__file = "Alipaychange.vue"
export default component.exports